import styled from "styled-components";
import excelIco from "../imgs/exel.png" ;
import Flotante from "./flotante.jsx";



const Container=styled.div`
height:88vh;
overflow:auto;
position:relative;
display:flex;
`
const ContainerFlotante=styled.div`
position: absolute;
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
top:55px;
left:3vw;
`

export default function Digemid (){


	return (
			<Container>
			<ContainerFlotante>
				<Flotante rutaIco={excelIco} texto="descarga el archivo ejemplo" archivo="digemid.xls" />
			</ContainerFlotante>
			<iframe title="digemid" src="https://opm-digemid.minsa.gob.pe/#/consulta-producto"   width="100%" height="100%"></iframe>
			</Container>
	)
}